import { Text } from 'bold-ui'
import { useFlags } from 'config/useFlagsContext'
import React from 'react'

import { NewsBalancedTopicsSection } from './NewsBalancedTopicsSection'

export function NewsModalBodyLinks() {
  const { GARANTIA_ACESSO_CIDADAO_OBITO, PILOTO_INTEGRACAO_REGULACAO_ENABLED } = useFlags()

  return (
    <NewsBalancedTopicsSection>
      <Text component='li'>Anexo de arquivos no prontuário</Text>
      <Text component='li'>Atualização da Ficha de notificação de caso suspeito</Text>
      <Text component='li'>Avaliação do M-CHAT-R na puericultura</Text>
      <Text component='li'>Novas funcionalidades para o Acompanhamento de condições de saúde</Text>
      <Text component='li'>Novas funcionalidades para o Cuidado compartilhado</Text>
      <Text component='li'>Novo relatório para monitoramento de envios para RNDS</Text>
      <Text component='li'>Novo relatório gerencial de exames</Text>
      <Text component='li'>Novos gráficos para crianças, adolescentes e gestantes</Text>
      <Text component='li'>Novo módulo e melhorias no registro de Atividades coletivas</Text>
      {PILOTO_INTEGRACAO_REGULACAO_ENABLED && (
        <Text component='li'>Notificações no módulo de Regulação assistencial</Text>
      )}
      {PILOTO_INTEGRACAO_REGULACAO_ENABLED && <Text component='li'>Regulação assistencial</Text>}
      {GARANTIA_ACESSO_CIDADAO_OBITO && <Text component='li'>Indicação de óbito na Garantia de acesso</Text>}
    </NewsBalancedTopicsSection>
  )
}
